/**
2  *  Copyright (c) 2022 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ZsdRoutingModule } from './zsd-routing.module';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';

/* Logging Service and Translate Service */
import { ZsdLoggingService } from './common/zsd-logging.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { EditorModule } from '@tinymce/tinymce-angular';

/* Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestInterceptor } from './shared/request.interceptor';
import { ResponseInterceptor } from './shared/response.inteceptor';
import { TokenService } from './shared/auth/token.service';
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';

/* Auth Guard */
import { AuthGuard } from './shared/guard/auth.guard';
import { HomeAuthGuard } from './shared/guard/homeauth.guard';
import { CommonConstants } from './common/constants/common-constants';
import { CustomerPreferenceService } from './customer/preference/customerpreference.service';
import { CommonRouteGuard } from './shared/guard/commonrouteguard';
import { CustomerPreferenceUtil } from './customer/preference/customerpreferenceutil';
import { ToastrModule } from 'ngx-toastr';

export function jwtOptionsFactory(tokenService: TokenService) {
  return {
    tokenGetter: () => {
      return tokenService.getToken();
    },
    whitelistedDomains: [location.host],
    blacklistedRoutes: [CommonConstants.SERVICE_VERSION_PATH_V1 + '/domains', CommonConstants.SERVICE_VERSION_PATH_V1 + '/auth/tokens',
    CommonConstants.SERVICE_VERSION_PATH_V1 + '/ssprlink', CommonConstants.SERVICE_VERSION_PATH_V1 + '/auth/login']
  };
}

export function translateLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/strings_', '.json');
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    ZsdRoutingModule,
    EditorModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (translateLoaderFactory),
        deps: [HttpClient]
      }
    }),
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [TokenService]
      }
    }),
    ToastrModule.forRoot({
      maxOpened: 1, // Max toasts opened. Toasts will be queued. 0 is unlimited
      autoDismiss: true, // Dismiss current toast when max is reached
      timeOut: 10000,
      positionClass: 'toast-top-center'
    })
  ],
  exports: [TranslateModule, ToastrModule],
  providers: [
    AuthGuard,
    CommonRouteGuard,
    CustomerPreferenceUtil,
    TokenService,
    ZsdLoggingService,
    CustomerPreferenceService,
    HomeAuthGuard,
   { provide: APP_BASE_HREF, useValue: '/servicedesk/' },
    // HTTP_INTERCEPTOR will be executed in the order provided
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true }
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {

}
